import { sendErrorNotice, sendSuccessNotice, refreshResource } from '@/commons/utils';
import { upload_file, request_list, request_detail, export_list } from '@/commons/hpod';
import Vue from 'vue';
import Crud from './crud'
var FileSaver = require('file-saver');
var crud = new Crud('products', 'hàng hóa');

const state = {
    ...crud.state,
    availableList: [],
    orderList: {},
    billList: {},
    selected: {
        ID: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    import_data({ commit }, formData) {
        commit("setLoading", { loading: true });
        upload_file(crud.endpoint, res => {
            commit("setLoading", { loading: false });
            if(res.status == 202) {
                sendErrorNotice(res.data.reason);
            }
            else {
                refreshResource();
                sendSuccessNotice('Import file thành công.');
            }
        }, Vue.http, formData, this.state.authentication.token, 'import');
    },
    getAvailableList({ commit }, param) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_list(`${crud.endpoint}/available`, data => {
                    commit('setAvailableList', data);
                    commit("setLoading", { loading: false });
                }, Vue.http, param, this.state.authentication.token);
            }, 100)
        })
    },
    getOrderList({ commit }, id) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_detail(`${crud.endpoint}/order`, data => {
                    commit('setOrderList', data);
                    commit("setLoading", { loading: false });
                }, Vue.http, id, this.state.authentication.token);
            }, 100)
        })
    },
    getBillList({ commit }, id) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_detail(`${crud.endpoint}/bill`, data => {
                    commit('setBillList', data);
                    commit("setLoading", { loading: false });
                }, Vue.http, id, this.state.authentication.token);
            }, 100)
        })
    },
    exportList({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list('products', res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
            FileSaver.saveAs(blob, `ma_bill_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export_list');
    },
};
const mutations = {
    ...crud.mutations,
    setAvailableList(state, ret) {
        state.availableList = ret.data;
    },
    setOrderList(state, ret) {
        state.orderList = ret;
    },
    setBillList(state, ret) {
        state.billList = ret;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};